import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from 'client/components/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { push } from 'react-router-redux'
import { Button, Paper, Typography } from '@material-ui/core';

class PartDialog extends Component {

   partLinkHandler () {
       const { dispatch} = this.props
       dispatch(push(`/c/${this.props.customerId}/parts/${this.props.part.id}`))
   }

  render () {
    const {classes, part, type, customerId, modalVisible, closeModal} = this.props;
    return (
        <Dialog onClose={closeModal} open={modalVisible}>
            {part && <>
            <DialogTitle onClose={closeModal}>
                {part.title}
            </DialogTitle>
            <DialogContent>
                    { part.condition_text ? <Paper className={`${classes.paperWithoutHeight} ${classes.smallPaper} ${classes.marginBottomTen}`}>
                    <Typography variant="subtitle2">Tilstandsvurdering</Typography>
                    <Typography>
                            {part.condition_text.split('\n').map((line, idx) => {
                                return (
                                    <span key={ idx }>
                                    { line }
                                    <br />
                                    </span>
                                )
                            })}
                    </Typography></Paper> : null }
                
                <Paper className={`${classes.paperWithoutHeight}  ${classes.smallPaper} ${classes.marginBottomTen}`}>
                    <Typography variant="subtitle2">Specifikation</Typography>
                    <Typography>
                    { part.specification }
                    </Typography>
                </Paper>
                <Paper className={`${classes.paperWithoutHeight}  ${classes.smallPaper}`}>
                    <Typography variant="subtitle2">Billeder</Typography>
                    <div className="row image-gallery">
                    {
                        part.images.map((image, idx) =>
                        <div key={ idx } className="col-md-4">
                            <img src={ `https://ik.imagekit.io/aw3ddey5g/${image.s3_image_id}?tr=w-400,h-233` } className="img-responsive" />
                        </div>
                        )
                    }
                    </div>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => this.partLinkHandler()} className={classes.button}>Vis bygningdel</Button>
            </DialogActions>
            </>}
        </Dialog>
    )
  }
}


const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PartDialog))